var ExternalAuthenticateCodeModel = /** @class */ (function () {
    function ExternalAuthenticateCodeModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalAuthenticateCodeModel.prototype.init = function (data) {
        if (data) {
            this.provider = data["provider"];
            this.code = data["code"];
            this.state = data["state"];
        }
    };
    ExternalAuthenticateCodeModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalAuthenticateCodeModel();
        result.init(data);
        return result;
    };
    ExternalAuthenticateCodeModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["provider"] = this.provider;
        data["code"] = this.code;
        data["state"] = this.state;
        return data;
    };
    ExternalAuthenticateCodeModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ExternalAuthenticateCodeModel();
        result.init(json);
        return result;
    };
    return ExternalAuthenticateCodeModel;
}());
export { ExternalAuthenticateCodeModel };
